export default __webpack_public_path__ + "static/media/selectPortH.efdacc05.png";